import { Node, mergeAttributes, InputRule } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react'
import latexInlineComponent from './latexInline.tsx'


export default Node.create({
  name: 'latexInline',

  inline: true,
  group: 'inline',
  atom: true,

  addAttributes() {
    return {
      id: {
        default: crypto.randomUUID()
      },
      metaData: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-metaData'),
        renderHTML: (attributes) => {
          return {
            'data-metaData': attributes.metaData,
          }
        },
      },
      firstCreate: { //控制创建的时候是否出现弹窗
        default: false
      },
      highlightImgUrl: {
        default: ''
      },
      ifhidden: {
        default: false,
        renderHTML: attributes => {
          if (attributes.ifhidden === undefined) {
            return {};
          }
          return {
            'ifhidden': attributes.ifhidden,
          };
        },
      },
      dollarBoundaries: {
        default: 2
      }
    }
  },
  parseHTML() {
    return [
      {
        tag: 'latex-inline',
        getAttrs: element => {
          // 必须显式解析属性
          return {
            firstCreate: element.getAttribute('data-firstCreate') === 'true',
            metaData: element.getAttribute('data-metaData') || ""
          };
        },
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return ['latex-inline', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return (props) => {
      return ReactNodeViewRenderer(latexInlineComponent)(props);
    };
  },
  addInputRules() {
    return [
      new InputRule({
        find: /\$\$(.*?)\$\$|(?<!\$)\$(?!\s)(?!\$)(?!.*?\$\d)(.*?\S?)(?<!\s)\$/gs, // 全局匹配 $之间的公式
        handler: ({ state, range, match, chain }) => {
          const blockContent = match[1]
          const inlineContent = match[2]
          const content = blockContent ?? inlineContent
          // console.log(2233,range,state.doc.textBetween(range.from - 1, range.from));
          // if (inlineContent !== undefined && !inlineContent.trim()) {
          //   return
          // }
          // debugger
          if (!content) return
          const pos = range.from
          const char = state.doc.textBetween(pos - 1, pos)
          const char2 = state.doc.textBetween(range.to - 1, range.to)
          if (char === '$') {
            range.from = range.from - 1;
          }
          chain()
              .command(({ tr }) => {
                tr.replaceWith(range.from, range.to, tr.doc.type.schema.nodes.latexInline.create({
                  metaData: content.trim(),
                  id: crypto.randomUUID(),
                  dollarBoundaries: blockContent ? 2 : 1
                }))
                return true
              })
              .run()
        },
      }),
    ];
  },
});